import { Component, OnInit } from '@angular/core';
import {
    FormGroup,
    FormBuilder,
    Validators,
    FormControl,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'app/providers/api.service';
// import { NzNotificationService, NzMessageService } from 'ng-zorro-antd';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { NotificationService } from '../create-ticket/create-ticket.component.scss';
// import { CreateTicketComponent } from '../../help-docs/create-ticket';
import { Injectable } from '@angular/core';
import { ThemeService } from 'ng2-charts';

import { MatIconModule } from '@angular/material/icon'
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { Console } from 'console';

import { MatOptionModule } from '@angular/material/core';

@Component({
    selector: 'app-create-ticket',
    templateUrl: './create-ticket.component.html',
    styleUrls: ['./create-ticket.component.scss'],
})
//  export class NotificationService {}
export class CreateTicketComponent implements OnInit {
    goBack;

    ticketForm: FormGroup;
    selectedFile;
    fnlImgs;
    attach_image: {};
    typeList;
    ctgryList;
    subctgryList;
    isetypeList;
    iseidnfrList;
    teamList;
    prtyList;
    status;
    TypeID;
    categryID;
    subcategryID;
    issueTypeID;
    issueIndefierID;
    teamID;
    shrtdescn;
    lngdescn;
    app_icon;
    CreateTicketDtls: any;
    CategoryDtls: any;
    subCategoryDtls = [];
    issueTypesDtls: any;
    issueIndefierDtls: any;
    teamsDtls: any;
    stsDtls: any;
    prtyDtls: any;
    loader: boolean;
    shwctgry = false;
    shwsbctgry = false;
    shwisetype = false;
    shwiseidtfr = false;
    shwteam = false;

    constructor(
        public router: Router,
        public fb: FormBuilder,
        public apiSrv: ApiService,
        private snackBar: MatSnackBar
    ) { }

    ngOnInit() {
        this.getDetailsToCreate();
        this.getStatus();
        this.getpriority();
    }

    getDetailsToCreate() {
        this.loader = true;
        const rte = 'ticket/creation';
        this.apiSrv.get(rte).subscribe((res) => {
            this.CreateTicketDtls = res['data'];
            console.log(this.CreateTicketDtls);
            console.log(this.CreateTicketDtls.length);
            this.loader = false;
            if (this.CreateTicketDtls.length == 1) {
                this.TypeID = this.CreateTicketDtls[0].tckt_type_id;
                this.ForCategory();
            } else {
                this.TypeID = '';
            }
        });
    }

    ForCategory() {
        console.log(this.TypeID);
        this.categryID = '';
        this.subcategryID = '';
        this.issueTypeID = '';
        this.issueIndefierID = '';
        this.teamID = '';
        const rte = `cpayOldWebRtr/getktcatgerylst/${this.TypeID}`;
        this.apiSrv.get(rte).subscribe((res) => {
            this.CategoryDtls = res['data'];
            console.log(this.CategoryDtls);
            console.log(this.CategoryDtls.length);
            if (this.CategoryDtls.length == 1) {
                this.categryID = this.CategoryDtls[0].tckt_ctgry_id;
                this.ForSubCategory();
            } else if (this.CategoryDtls.length > 1) {
                this.categryID = '';
            } else {
                this.shwctgry = true;
            }
        });
    }

    ForSubCategory() {
        console.log(this.categryID);
        this.subcategryID = '';
        this.issueTypeID = '';
        this.issueIndefierID = '';
        this.teamID = '';
        // this.ForTeams();
        const rte = `cpayOldWebRtr/getktsbcatgerylst/${this.categryID}`;
        this.apiSrv.get(rte).subscribe((res) => {
            console.log(res)
            console.log(res['status'])
            if (res['status'] === 200) {
                this.subCategoryDtls = res['data'];
                console.log(this.subCategoryDtls);
                console.log(this.subCategoryDtls.length);
                if (this.subCategoryDtls.length == 1) {
                    this.subcategryID = this.subCategoryDtls[0].tckt_sb_ctgry_id;
                    this.ForIssueType();
                } else if (this.subCategoryDtls.length > 1) {
                    this.subcategryID = '';
                } else {
                    this.shwsbctgry = true;
                }
            } else {
                this.apiSrv.openNotification('error', 'user details',  'Something went wrong.',)

 
            }
        });
    }

    ForIssueType() {
        console.log(this.subcategryID);
        this.issueTypeID = '';
        this.issueIndefierID = '';
        this.teamID = '';

        const rte = `ticket/getissueTypes/${this.categryID}/${this.subcategryID}`;
        this.apiSrv.get(rte).subscribe((res) => {
            this.issueTypesDtls = res['data'];
            console.log(this.issueTypesDtls);
            console.log(this.issueTypesDtls.length);
            if (this.issueTypesDtls.length == 1) {
                this.issueTypeID = this.issueTypesDtls[0].ise_type_id;
                // this.ForIssueIndefiers();
            } else if (this.issueTypesDtls.length > 1) {
                this.issueTypeID = '';
            } else {
                this.shwisetype = true;
            }
        });
    }

    // ForIssueIndefiers() {
    //     this.issueIndefierID = '';
    //     this.teamID = '';

    //     const rte = `ticket/getissueIdentifiers/${this.issueTypeID}`;
    //     this.apiSrv.get(rte).subscribe((res) => {
    //         this.issueIndefierDtls = res['data'];
    //         console.log(this.issueIndefierDtls);
    //         console.log(this.issueIndefierDtls.length);
    //         if (this.issueIndefierDtls.length == 1) {
    //             this.issueIndefierID = this.issueIndefierDtls[0].ise_idnfr_id;
    //         } else if (this.issueIndefierDtls.length > 1) {
    //             this.issueIndefierID = '';
    //         } else {
    //             this.shwiseidtfr = true;
    //         }
    //     });
    // }

    // ForTeams() {
    //   console.log(this.issueIndefierID);
    //   this.teamID = '';
    //   var data = {
    //     type: this.TypeID ? this.TypeID : 0,
    //     category: this.categryID ? this.categryID : 0,
    //     subcategory: this.subcategryID ? this.subcategryID : 0,
    //     issuetype: this.issueTypeID ? this.issueTypeID : 0,
    //     isseidentifier: this.issueIndefierID ? this.issueIndefierID : 0
    //   }
    //   console.log(data);
    //   this.apiSrv.create(data, 'ticket/getTeams').subscribe(res => {
    //     this.teamsDtls = res['data'];
    //     console.log(this.teamsDtls);
    //     console.log(this.teamsDtls.length);
    //     if (this.teamsDtls.length == 1) {
    //       this.teamID = this.teamsDtls[0].tm_id;
    //     }
    //     else if(this.teamsDtls.length > 1){
    //       this.teamID = ''
    //     }
    //     else{
    //       this.shwteam = true;
    //     }
    //   })
    // }

    getStatus() {
        const rte = 'ticket/Ticket-Status';
        this.apiSrv.get(rte).subscribe((res) => {
            this.stsDtls = res['data'];
            console.log(this.stsDtls);
        });
    }
    getpriority() {
        const rte = 'ticket/Priority';
        this.apiSrv.get(rte).subscribe((res) => {
            this.prtyDtls = res['data'];
            console.log(this.prtyDtls);
        });
    }

    onSelectFile(event) {
        console.log(event)
        if (event.target.files && event.target.files[0]) {
            this.selectedFile = event.target.files[0].name;
            let reader = new FileReader();
            reader.onload = (event: any) => {
                this.fnlImgs = event.target.result;
                let img = {};
                img = {
                    base64: this.fnlImgs,
                    file_name: this.selectedFile,
                };
                this.attach_image = img;
                console.log(this.attach_image)
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    // handleInputChange(e) {
    //     this.attachments = []
    //     let files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
    //     console.log(files,files[0].fl_type,files[0].type)
    //     // for (var i = 0; i < files.length; i++) {
    //       if (files[0].type == 'image/jpg'  ||files[0].type == 'image/png' ||   files[0].type == 'application/pdf' || files[0].type == 'image/jpeg' ) {
    //         let file = files[0];
    //         this.fl_type = file.type;
    //         this.fl_nm = file.name;
    //         let reader = new FileReader();
    //         reader.onload = this._handleReaderLoaded.bind(this);
    //         reader.readAsDataURL(file);
    //       }
    //       else {
    //         this._mailboxService.openSnackBar('Please Upload Valid File.', 'mat-warn');
    //       }

    //     // }
    // }


    removeImg() {
        this.fnlImgs = '';
        this.selectedFile = '';
        this.app_icon = '';
    }

    resetform() {
        this.TypeID = '';
        this.categryID = '';
        this.subcategryID = '';
        this.issueTypeID = '';
        this.issueIndefierID = '';
        this.teamID = '';
        this.fnlImgs = '';
        this.selectedFile = '';
        this.app_icon = '';
        this.shrtdescn = '';
        this.lngdescn = '';
    }

    saveform() {
        console.log(this.TypeID);
        console.log(this.categryID);
        console.log(this.subcategryID);
        if (this.attach_image != undefined || '') {
            this.attach_image = this.attach_image;
        } else {
            let img1 = {};
            img1 = {
                base64: this.fnlImgs,
                file_name:
                    this.selectedFile == undefined ? null : this.selectedFile,
            };
            this.attach_image = img1;
        }
        var postdata = {
            type: this.TypeID,
            category: this.categryID,
            subcategory: this.subcategryID > 0 ? this.subcategryID : 0,
            team: 1,
            status: 7,
            priority: 3,
            cre_tm_id: 2,
            shrtdscn: this.shrtdescn
                ? this.shrtdescn.length > 0
                    ? this.shrtdescn
                    : 0
                : 0,
            lngdscn: this.lngdescn
                ? this.lngdescn.length > 0
                    ? this.lngdescn
                    : 0
                : 0,
            attach_data: this.attach_image,
        };

        this.loader = true;
        console.log(postdata);
        this.apiSrv
            .create(postdata, 'ticket/insert/newticket')
            .subscribe((res) => {
                console.log(res);
                if ((res['status'] = 200)) {
                    this.loader = false;
                    this.goback();
                    // this.notificationService.createMessage('success', 'Ticket Successfully Created');
                    this.apiSrv.openNotification('success', 'user details',   'Ticket created Successfully',)

                    
                } else {
                    this.apiSrv.openNotification('error', 'user details', 'Something went wrong.')

                }
            });
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action);
    }

    goback() {
        this.router.navigate([`support/help`]); //,{ queryParams: {id: 37, username: 'jimmy'}}
    }
}
